import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Icon, Popover } from 'antd';
import { withTranslation } from 'react-i18next';

import money from '../../helpers/money';
import './BalanceDisplayer.scss';
import AccountRepo from '../../repository/account';

const fetchAccount = async ({ id: accountId, business_id: businessId }) => {
  const { data: { balance } } = await AccountRepo.fetch({ id: businessId }, accountId);
  return { data: balance };
};

const BalanceDisplayer = ({ account, updateBalance = fetchAccount, className = '', showUpdatedAt = false, t }) => {
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(account.balance);
  const [error, setError] = useState(false);

  const onSync = async () => {
    setLoading(true);
    try {
      const { data } = await updateBalance(account);
      setBalance(data);
      setError(false);
    } catch (currentError) {
      setError(true);
      console.error('ERROR: BalanceDiplayer: AccountRepo.updateBalance()', currentError); // eslint-disable-line no-console
    }
    setLoading(false);
  };

  const lastUpdate = new Date(balance.at);

  const content = (error) ? (
    <span className="update-error">{t('account.update_error')}</span>
  ) : (
    <span>{`${t('account.last_update')} ${lastUpdate.toLocaleString()}`}</span>
  );
  return (
    <div className={`balance-block ${className}`}>
      <div className="balance-amount">{`${money.toDisplay(((balance) ? balance.available : 0), account.region_id)}`}</div>
      {(showUpdatedAt) ? (
        <>
          <Icon className="balance-refresh" type="sync" onClick={onSync} spin={loading} />
          <div className="balance-last-update">{content}</div>
        </>
      ) : (
        <Popover content={content}>
          <Icon className="balance-refresh" type="sync" onClick={onSync} spin={loading} />
        </Popover>
      )}
    </div>
  );
};

BalanceDisplayer.propTypes = {
  account: PropTypes.shape({
    balance: PropTypes.shape({
      at: PropTypes.string,
      available: PropTypes.number,
    }),
    region_id: PropTypes.string,
  }),
  className: PropTypes.string,
  showUpdatedAt: PropTypes.bool,
  t: PropTypes.func,
  updateBalance: PropTypes.func,
};
const TranslatableBalanceDisplayer = withTranslation()(BalanceDisplayer);

export { TranslatableBalanceDisplayer as BalanceDisplayer };
